import { render, staticRenderFns } from "./RecordFirstTime.vue?vue&type=template&id=d5babaf0&scoped=true&"
import script from "./RecordFirstTime.vue?vue&type=script&lang=js&"
export * from "./RecordFirstTime.vue?vue&type=script&lang=js&"
import style0 from "./RecordFirstTime.vue?vue&type=style&index=0&id=d5babaf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5babaf0",
  null
  
)

export default component.exports